<template>
  <div>
      <div class="flex-spc-x fixed">
      <el-breadcrumb separator-class="el-icon-arrow-right" style="postion:fixed">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>消息模板</el-breadcrumb-item>
      </el-breadcrumb>
      <el-link type="primary" style="margin-right:220px" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
      </div>
    <!-- 面包屑导航 -->
    <!-- <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item :to="{ path: '/setting/setting' }">系统设置</el-breadcrumb-item>
     
      <el-link type="primary" style="float:right" @click="tosetting()"><i class="el-icon-back"></i> 返回</el-link>
    </el-breadcrumb> -->
    <div> 
        <div class="flexB" style="margin-bottom:10px;;padding-top:30px;">
                                <div style="font-size: 18px;">
                                    <label>剩余短信条数：</label>
                                    <span>{{SyNumber}}</span> &nbsp;&nbsp;&nbsp;&nbsp;
                                 <el-button type="primary"  @click="setContinue">充值</el-button>
                                </div>
                            
                             <div class="flexS">
                                <el-button type="default"  @click="CZinfo">充值明细</el-button>
                                <el-button type="default"  @click="DXinfo">发送明细</el-button>
                            </div>
        </div>
       <div class="flex-spc-x" style="width:100%;padding-bottom:50px">
                        <el-table
                             :data="ListSMSTemp"
                             tooltip-effect="dark"
                             border
                             stripe
                             style="width:100%">
                            <el-table-column type="index" label="序号" align="center" width=""></el-table-column>
                             <el-table-column label="名称" prop="SMSTempName"></el-table-column>
                            <el-table-column  label="模板介绍"  >
                                 <template slot-scope="scope">
                                  <span> {{scope.row.SMSTempInfo}}</span>
                            </template>
                            </el-table-column>
                            <el-table-column label="操作" align="center" width="">
                            <template slot-scope="scope">
                                <div class="flex-xy">
                                  <div class="flexc-cen-x">
                                    <el-switch :disabled="scope.row.isedit"
                                     v-model="scope.row.ison"
                                     on-color="#00A854"
                                    on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                      off-text="禁止"
                                     off-value="0"
                                 @change="changeSwitch(scope.row)">
                                    </el-switch>
                                     <el-popover
                                        placement="right-start"
                                        width="150"
                                        trigger="hover">
                                        <div  style="width:100%">
                                            <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                              <div>
                                                  <img src="../../assets/icon/mail.png" style="height:30px;widht:30px" alt="" srcset="">
                                              </div>
                                              <div style="margin-left:5px;font-size:14px;">短息·示例</div>
                                            </div>
                                            <div class="" style="width:100%;margin-top:20px;margin-bottom:15px;font-size:14px;">
                                              {{scope.row.SmsTemp}}
                                            </div>
                                        </div>
                      
                                            <div  slot="reference"  style="margin-left:10px">
                                                <el-button type="text">短息示例</el-button>
                                            </div>
                  
                                      </el-popover>
                                  </div>
                                   <div class="flexc-cen-x" v-if="scope.row.PushID>0" style="margin-left:14px">
                                    <el-switch  :disabled="scope.row.isedit"
                                     v-model="scope.row.xcxison"
                                     on-color="#00A854"
                                    on-text="启动"
                                     on-value="1"
                                     off-color="#F04134"
                                      off-text="禁止"
                                     off-value="0"
                                   @change="changeSwitch1(scope.row)">
                                    </el-switch>
                                     <el-popover
                                        placement="right-start"
                                        width="150"
                                        trigger="hover">
                                        <div  style="width:100%">
                                            <div class="flexc-cen-x" style="border-bottom:1px solid #e6f7ff;padding-bottom:5px">
                                              <div>
                                                  <img src="../../assets/icon/wechat.png" style="height:30px;widht:30px" alt="" srcset="">
                                              </div>
                                              <div style="margin-left:5px;font-size:14px;">小程序·示例</div>
                                            </div>
                                          <div class="w100" v-if="scope.row.TempType == 3" style="font-size:15px;margin-top:10px;">预约成功通知</div>
                                           <div class="w100" v-if="scope.row.TempType == 4" style="font-size:15px;margin-top:10px;">取消预约通知</div>
                                            <div class="w100" v-if="scope.row.TempType == 5" style="font-size:15px;margin-top:10px;">{{typeName}}通知</div>
                                            <div class="w100" v-if="scope.row.TempType == 12" style="font-size:15px;margin-top:10px;">人数不足取消预约通知</div>
                                            <div class="w100" v-if="scope.row.TempType == 13" style="font-size:15px;margin-top:10px;">上课提醒通知</div>
                                            <div class="w100" style="font-size:12px;margin-top:3px;color:#b3b3b3">10月10号 09:00</div>
                                            <div class="" v-if="scope.row.TempType == 3" style="width:100%;margin-top:20px;margin-bottom:15px;font-size:14px;">
                                                <div class="flex-spc-x">
                                                    <div style="color:#b3b3b3">课程名称</div>
                                                    <div>xx课</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">学员姓名</div>
                                                    <div>xxx</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">教师名称</div>
                                                    <div>xxx</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">预约时间</div>
                                        
                                                        <div>2020-12-01 12:00~13:00</div>
                                           

                                                </div>
                                                 <div class="flex-spc-x w100" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">服务门店</div>
                                                    <div>xx店</div>
                                                </div>
                                            </div>
                                            <div class="" v-if="scope.row.TempType == 4" style="width:100%;margin-top:20px;margin-bottom:15px;font-size:14px;">
                                                <div class="flex-spc-x">
                                                    <div style="color:#b3b3b3">场馆名称</div>
                                                    <div>xx馆</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">课程名称</div>
                                                    <div>xxx课</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">课节日期</div>
                                                    <div>2020-12-01 12:00~13:00</div>
                                                </div>
                                                 <div class="flex-spc-x"  style="margin-top:3px">
                                                    <div style="color:#b3b3b3">状态</div>
                                                    <div >取消预约</div>
                                                </div>
                                                 <div class="flex-spc-x w100">
                                                    <div style="color:#b3b3b3">温馨提示</div>
                                                    <div>xxx</div>
                                                </div>
                                            </div>
                                              <div class="" v-if="scope.row.TempType == 5" style="width:100%;margin-top:20px;margin-bottom:15px;font-size:14px;">
                                                <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">场馆名称</div>
                                                    <div>xx馆</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">课程名称</div>
                                                    <div>xxx课</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">课节日期</div>
                                                    <div>2020-12-01 12:00~13:00</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">状态</div>
                                                    <div >{{typeName}}</div>
                                                </div>
                                                 <div class="flex-spc-x w100" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">温馨提示</div>
                                                    <div>xxx</div>
                                                </div>
                                            </div>
                                            <div class="" v-if="scope.row.TempType == 12" style="width:100%;margin-top:20px;margin-bottom:15px;font-size:14px;">
                                                <div class="flex-spc-x" >
                                                    <div style="color:#b3b3b3">店铺名称</div>
                                                    <div>xx店</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">课程名称</div>
                                                    <div>xxx课</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">上课时间</div>
                                                     <div>2020-12-01 12:00~13:00</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">上课地点</div>
                                                    <div>xxx</div>
                                                </div>
                                                 <div class="flex-spc-x w100" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">温馨提示</div>
                                                    <div>人数不足取消</div>
                                                </div>
                                            </div>

                                            <div class="" v-if="scope.row.TempType == 16" style="width:100%;margin-top:20px;margin-bottom:15px;font-size:14px;">
                                                <div class="flex-spc-x">
                                                    <div style="color:#b3b3b3">店铺名称</div>
                                                    <div>xx店</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">课程名称</div>
                                                    <div>xxx课</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">上课时间</div>
                                                     <div>2020-12-01 12:00~13:00</div>
                                                </div>
                                                 <div class="flex-spc-x" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">上课地点</div>
                                                    <div>xxx</div>
                                                </div>
                                                 <div class="flex-spc-x w100" style="margin-top:3px">
                                                    <div style="color:#b3b3b3">温馨提示</div>
                                                    <div>准时参加</div>
                                                </div>
                                            </div>
                                        </div>
                      
                                            <div  slot="reference"  style="margin-left:10px">
                                                <el-button type="text">小程序示例</el-button>
                                            </div>
                  
                                      </el-popover>
                                  </div>
                                </div>
  
                                       
                            </template>
                        </el-table-column>
                        </el-table>
        
    </div>
    </div>

    <el-dialog title="充值记录" :visible.sync="showchongzhiDrawer" width="700px">
    <el-table  :data="ListSMSBuyDetail" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;">
         <el-table-column label="购买用户" prop="LoginName"  ></el-table-column>
         <el-table-column label="购买套餐" prop="consumptionInfo"  ></el-table-column>
         <el-table-column label="购买金额" prop="consumptionAmount"> </el-table-column>
         <el-table-column label="购买条数" prop="Number"  ></el-table-column>
         <el-table-column label="购买时间" prop="addTime"  ></el-table-column>
    </el-table>
     <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取消</el-button>
         </div>
    </el-dialog>

    <el-dialog title="发送记录" :visible.sync="showduanxinDrawer" width="700px" >
    <el-table  :data="ListSMSRecord" highlight-current-row v-loading="loading"  element-loading-text="拼命加载中" style="width: 100%;">
 
         <el-table-column label="手机号" prop="phone"  ></el-table-column>
                              <el-table-column label="短信类型" prop="SMSTempType"  >
                                <template slot-scope="scope">
                                    <span v-if="scope.row.SMSTempType=='1'">验证码</span>
                                    <span v-if="scope.row.SMSTempType=='2'">续费提醒</span>
                                    <span v-if="scope.row.SMSTempType=='3'">课程预约</span>
                                    <span v-if="scope.row.SMSTempType=='4'">取消预约</span>
                                    <span v-if="scope.row.SMSTempType=='5'">签到提醒</span>
                                    <span v-if="scope.row.SMSTempType=='6'">撤销提醒</span>
                                    <span v-if="scope.row.SMSTempType=='7'">课程预约成功通知老师</span>
                                    <span v-if="scope.row.SMSTempType=='8'">课程取消预约通知老师</span>
                                    <span v-if="scope.row.SMSTempType=='9'">其他通知</span>
                                    <span v-if="scope.row.SMSTempType=='10'">停课通知</span>
                                    <span v-if="scope.row.SMSTempType=='11'">放假通知</span>
                                    <span v-if="scope.row.SMSTempType=='12'">人数不足取消上课提醒学员</span>
                                    <span v-if="scope.row.SMSTempType=='13'">上课提醒老师和学员</span>
                                    <span v-if="scope.row.SMSTempType=='14'">人数不足取消上课提醒老师</span>
                                    <span v-if="scope.row.SMSTempType=='15'">消课成功提醒</span>
                                 </template>
                              </el-table-column>
                               <el-table-column label="短信内容" prop="SMSInfo"  ></el-table-column>
                              <el-table-column label="发送时间" prop="addTime"  ></el-table-column>
                              <el-table-column label="发送状态" prop="state"  >
                                   <template slot-scope="scope">
                                    <span v-if="scope.row.state=='1'">成功</span>
                                    <span v-if="scope.row.state=='0'">失败</span>
                                 </template>
                              </el-table-column>
    </el-table>
     <Pagination v-bind:child-msg="pageparm" @callFather="callFather1"></Pagination>
        <div slot="footer" class="dialog-footer">
            <el-button size="small" @click="closeDialog">取消</el-button>
         </div>
    </el-dialog>
    <el-dialog title="短信充值" :visible.sync="showRightDrawer" width="700px" >
    <el-form :model="PayForm" ref="PayForm" label-width="130px" label-position="right">
                    <el-form-item label="充值套餐：">
                        <div class="BuyBoxWrap">
                            <div class="BuyBox" :class="idx==index?'hover':''" v-for="(item,idx) in BuyList" :key="idx" @click="getChoosed(item,idx)">
                                <p><b>{{item.title}}</b></p>
                                <p>{{item.Contents}}</p>
                            </div>
                            <!-- {{PayForm}} -->
                        </div>
                    </el-form-item>
                    <el-form-item label="支付方式：">
                        <el-radio-group v-model="PayForm.Type">
                            <el-radio label="1"><i class="iconfont icon-wxPay"></i> 微信支付</el-radio>
                         </el-radio-group>
                    </el-form-item>
                    <el-form-item label="应付金额：">
                        {{PayForm.BuyAmount}}
                    </el-form-item>
                    <el-form-item>
                        <!-- @hide="changePopShow" -->
                        <el-popover
                            placement="top"
                            width="100"
                            trigger="click"
                            @hide="changePopShow"
                            v-if="showPopover || Qrcode!==''"
                            >
                            <div style="text-align:center;">
                                <el-image
                                style="width: 100px; height: 100px;margin:10px;"
                                :src="QrcodeImg" fit="cover"></el-image>
                                <p>请用微信扫码支付</p>
                            </div>
                            <el-button slot="reference" type="primary" size="medium" @click="submitToPay">确认购买</el-button>
                        </el-popover>
                         <el-button @click="closePayDrawer">取消</el-button>
                    </el-form-item>
                </el-form>  
    </el-dialog>
  </div> 
</template>
<script>
import CropperImage from "../../components/CropperImage";
import Pagination from '../../components/Pagination'
import QRCode from 'qrcode'
export default {
  data() {
    return {
 
    DianList:[],
    SelectStoresID:localStorage.getItem("StoresID"),
    tableLoading:false,
    loading :false,
    showchongzhiDrawer:false,
    showduanxinDrawer:false,
    showRightDrawer:false,
    Qrcode:"",
    NotifyId:"",
    QrcodeImg:"",
    overtype:0,
    SyNumber:0,
    index:0,
    BuyList:[],
    showPopover:true,
    timer:null,
    ListPaySetting:[],
    ListSMSRecord:[],
    ListSMSBuyDetail:[],
      formInline: {
        page: 1,
        limit: 10,
        varLable: '',
        varName: '',
        token: localStorage.getItem('logintoken')
      },
      
    WZYGName:'',
    WZHYName:'',
    WZXMName:'',
    WZPBName:'',
      pageparm: {
        currentPage: 1,
        pageSize: 10,
        total: 10
      },
      typeName:'',
      PayForm:{
                    BuyID:"1",
                    Type:"1",
                    BuyAmount:"",
                }
    
    }
  },
  // 注册组件
  components: {
    Pagination,
     CropperImage,
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
        this.WZYGName = localStorage.getItem('WZYGName')
    this.WZHYName = localStorage.getItem('WZHYName')
    this.WZXMName = localStorage.getItem('WZXMName')
    this.WZPBName = localStorage.getItem('WZPBName')
         this.getList()
           if(localStorage.getItem('StoresType')== 1){
          this.typeName = '签到'
        
      }  else {
          this.typeName = '核销'
        
      }     
  },
 destroyed(){
            clearInterval(this.timer)
            this.timer = null
            // console.log(this.timer,1)
 },
 beforeDestroy(){
            clearInterval(this.timer);
            this.timer = null
          },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      tosetting(){
          this.$router.go(-1)
      } ,
      getList(){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
        const loading = this.$loading({
              lock: true,
              text: '加载中...',
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            });
      this.ajax('getListSMSTemp.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.ListSMSTemp = res.data
                that.SyNumber = res.info.SyNumber;

            for (let i = 0; i < res.data.length; i++) {
            
                    if(res.data[i].isedit =='0'){
                        that.ListSMSTemp[i].isedit = false;

                        }else{
                        that.ListSMSTemp[i].isedit = true;

                        }
                        if(res.data[i].ison =='1'){
                        that.ListSMSTemp[i].ison = true;

                        }else{
                        that.ListSMSTemp[i].ison = false;

                        }
                        if(res.data[i].xcxison =='1'){
                        that.ListSMSTemp[i].xcxison = true;

                        }else{
                        that.ListSMSTemp[i].xcxison = false;

                        }
                    }
          } 
          loading.close();
      })
  
  
    },
    changeSwitch(val){
                  let ison1 = 0;
               if(val.ison){
                   ison1 =1;
               }else{

                   ison1 =0;
               }

               this.ediSMSTempIson(val.ID , ison1);
            }, ediSMSTempIson(SMSTempID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SMSTempID:SMSTempID,
           Ison:Ison
         }
     
      
        var that = this
         this.ajax('ediSMSTempIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
              //    that.$message({
              //   type: "success",
              //   message: res.Msg,
              // });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

            },
         changeSwitch1(val){
              let ison1 = 0;
               if(val.xcxison){
                   ison1 =1;
               }else{

                   ison1 =0;
               }

               this.ediSMSTempIson1(val.PushID , ison1);
            }, 
          ediSMSTempIson1(SMSTempID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          PushID:SMSTempID,
           Ison:Ison
         }
     
      
        var that = this
         this.ajax('editTempPushxcxIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
              //    that.$message({
              //   type: "success",
              //   message: res.Msg,
              // });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

            },       
            ediSMSTempIson(SMSTempID,Ison){

       this.tableLoading = true
       var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          SMSTempID:SMSTempID,
           Ison:Ison
         }
     
      
        var that = this
         this.ajax('ediSMSTempIson.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.tableLoading = false
                that.getList();
              //    that.$message({
              //   type: "success",
              //   message: res.Msg,
              // });
 
                }else{
                     that.$message({
                type: "error",
                message: res.Msg,duration:2000,
              });
                  
                 }

      })

            },       
            setContinue(){
                this.getListSMSBuy();
            },getListSMSBuy(){
        var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
    
      }
     
      
        var that = this
      this.ajax('getListSMSBuy.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.BuyList = res.data
               that.showRightDrawer = true 
                that.showPopover = true;
                that.Qrcode="";
               if(res.data.length>0){
                   that.getChoosed(res.data[0],0);
                }
 
          } 

      })
    },
            // 点击选中续期时间
            getChoosed (item,idx) {
                this.index=idx;
                 this.PayForm.BuyAmount = item.BuyAmount;
                this.PayForm.BuyID = item.ID;
            },
            changePopShow(){
                this.showPopover = false;
            },
            submitToPay(){
                this.DXCZPayqrcode();
                this.showPopover = true;
            },
            // 获取二维码
            DXCZPayqrcode(){
        var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          BuyID: this.PayForm.BuyID,
           LoginID: localStorage.getItem("LoginID") 
      }
     
      
        var that = this
      this.ajax('DXCZPayqrcode.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.Qrcode = res.QRurl;
                that.NotifyId = res.NotifyId;
                that.setQRCode(that.Qrcode);
                that.setTimer(2000,that.NotifyId);
          } 

      })
    }, setQRCode(str){
                QRCode.toDataURL(str, { width:150, margin:1 }).then(res=>{
                    this.QrcodeImg = res;
                })
            },
            setTimer(time,item) {
                // debugger
                this.timer = setInterval (() => {
                    this.getPayNotify(item)
                },time);
                this.$once('hook:beforeDestroy', () => {
                    clearInterval(this.timer);
                })

            },getPayNotify(item){

                  var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          NotifyId: item 
      }
     
      
        var that = this
      this.ajax('getNotify.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                 that.showRightDrawer = false;
                that.showPopover = false;
                that.Qrcode = "";
              that.getList();
               clearInterval(that.timer);
                        that.timer = null
          } 

      })
            }, closePayDrawer(){
                this.showRightDrawer = false;
                this.showPopover = false;
                this.Qrcode = "";
            },CZinfo(){
           this.getListSMSBuyDetail()
            }, DXinfo(){
                 this.getListSMSRecord()

            },closeDialog() {
            this.showchongzhiDrawer = false 
             this.showduanxinDrawer = false 
             this.showRightDrawer = false 
             },callFather(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getListSMSBuyDetail()
    },getListSMSBuyDetail(){
        var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
    
      }
     
      
        var that = this
      this.ajax('getListSMSBuyDetail.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.ListSMSBuyDetail = res.data
               that.showchongzhiDrawer = true 
               that.pageparm.total= res.allcount

          } 

      })
    },callFather1(parm) {
      this.formInline.page = parm.currentPage
      this.formInline.limit = parm.pageSize
      this.getListSMSRecord()
    },getListSMSRecord(){
        var data = { SelectStoresID:this.$route.params.id,
          token: localStorage.getItem("token"),
          StoresID:localStorage.getItem("StoresID"),
          pages:this.formInline.page,
          psize:this.formInline.limit,
    
      }
     
      
        var that = this
      this.ajax('getListSMSRecord.aspx',JSON.stringify(data),"POST",function(res){
          if (res.orsuccess == "1") {
                that.ListSMSRecord = res.data
               that.showduanxinDrawer = true 
               that.pageparm.total= res.allcount

          } 

      })
    }
   
  }
}
</script>
 <style>
 .el-popover{
    min-width:250px !important;
}
 </style>
 <style scoped>
 .flexB{
    display: flex;
    justify-content: space-between;
}
.flexS{
    display: flex;
    justify-content: flex-start;
}
 .BuyBoxWrap{
        display: flex;
        justify-content: flex-start;
    }
    .BuyBoxWrap .BuyBox{
        margin-top:10px;
        margin-right:20px;
        text-align: center;
        padding:15px 0;
        border:1px solid #ccc;
        width:150px;
        line-height: 1.8;
        cursor: pointer;
    }
    .BuyBoxWrap .BuyBox:hover, .BuyBoxWrap .BuyBox.hover{
        background:#409EFF;
        color:#fff;
        border:1px solid #409EFF;
    }
    .icon-wxPay{
        color: #41af35;
        font-size: 35px;
        display: inline-block;
        vertical-align: middle;
    }
</style>



// WEBPACK FOOTER //
// src/views/setting/SMSSettingInfo.vue